<template>
  <div id="app" :class="[$COMPANY_NAME]">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="less">
/* BI:全局统一设置背景样式 */
:root {
  /* 盒子背景色 */
  --background-image: linear-gradient(224deg, #f4fefe 0%, #e8f0fa 100%);
  /* 盒子阴影 */
  --box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
  /* 财务BI页面环形饼状图嵌套盒子背景色 */
  --lyzePie-backgroundColor: rgba(255, 255, 255, 0.5);
  --primary-color: #154f9d;
  --primary-color-hover: #4472b1;
  --primary-color-disable: #8aa7ce;
}

/* 动态样式切换 */
.jyd {
  --primary-color: #eecd22;
  --primary-color-hover: #fde571;
  --primary-color-disable: #feeea0;
}
.kr {
  --primary-color: #e62129;
  --primary-color-hover: #fa6065;
  --primary-color-disable: #fca2a5;
}

// [dataCompany='hf'] {
//   --primary-color: #b83431;
// }

.el-menu--vertical {
  top: 0 !important;
  left: 58px !important;

  .el-menu {
    height: 100vh;
    box-shadow: 12px 0px 12px 0px rgba(0, 0, 0, 0.08);
    .parent-title {
      padding: 16px 24px;
      font-size: 16px;
      font-weight: bold;
      color: var(--primary-color);
    }

    .el-menu-item {
      height: auto;
      line-height: normal;
      padding: 12px !important;
      margin: 12px;
      border-radius: 8px;
    }

    .el-menu-item:focus,
    .el-menu-item:hover {
      background: #fff;
      color: var(--primary-color) !important;

      i {
        color: var(--primary-color);
      }
    }

    .is-active:hover {
      background: var(--primary-color);
      color: #fff !important;

      i {
        color: #fff;
      }
    }

    .is-active {
      background: var(--primary-color);
      color: #fff !important;
    }
  }
}
</style>
